'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const PRIMITIVE_TYPES = [
    'string',
    'boolean',
    'number',
];
const isPrimitive = (value) => (PRIMITIVE_TYPES.includes(typeof value));
const isArrayOfPrimitive = (value) => {
    if (!Array.isArray(value)) {
        return false;
    }
    return value.every((arrayValue) => isPrimitive(arrayValue));
};

exports.isArrayOfPrimitive = isArrayOfPrimitive;
exports.isPrimitive = isPrimitive;
//# sourceMappingURL=is-primitive.js.map
